import { DbFile } from './db-file.entity';

export class CoronaTestResultFile {
  id?: number;
  comment?: string;
  file: DbFile;
}
